import React from 'react';

import {H2hWidgetProps} from "../models/h2h-widget.props";
import {H2hWidgetController} from "../h2h-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {H2hWidgetFullView} from "./h2h-widget.full-view";
import {H2hWidgetPartialView} from "./h2h-widget.partial-view";
import {H2hWidgetPlaceholder} from "./placeholder/h2h-widget.placeholder";
import {Loader} from "../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {H2hWidgetHeader} from "./h2h-widget.Header";

export class H2hWidgetComponentProps extends H2hWidgetProps {
  gameId: Number;
  isFullView: Boolean;
}

export const H2hWidgetComponent = ((props: H2hWidgetComponentProps) => {
  const additionalProps = {
    ...props,
  }

  const loaderProps = {
    when: props.controller.state.fetchingState === FETCHING_STATES.fetching || props.controller.state.componentState === COMPONENT_STATES.loading,
    Component: H2hWidgetPlaceholder,
    componentProps: {
      isFullView: props.isFullView
    }
  };

  return (
    <>
      {
        props.isFullView ? <H2hWidgetHeader controller={props.controller}/> : null
      }
      <Loader {...loaderProps}>
        {
          props.isFullView ? <H2hWidgetFullView {...additionalProps}/> : <H2hWidgetPartialView {...additionalProps}/>
        }
      </Loader>
    </>
  )
});

const settings: ComposeSettings = {
  propsType: H2hWidgetComponentProps,
  controllerType: H2hWidgetController,
  component: H2hWidgetComponent,

  observe: true,
  createModule: true,
};

export default Compose(settings);
